import {Module} from 'module/Module'
import {BSCollectionReducerNS} from 'module/BSCollection/reducer/BSCollectionReducer'
import {BSCollectionFetcherEpic} from 'module/BSCollection/epic/BSCollectionFetcherEpic'
import {BSStTagZuEpic} from 'module/BSCollection/epic/BSStTagZuEpic'
import {BSIstZeitEpic} from 'module/BSCollection/epic/BSIstZeitEpic'
import {SollIstEpic} from 'module/BSCollection/epic/BSSollIstEpic'
import {BSPersurlEpic} from 'module/BSCollection/epic/BSPersurlEpic'

/**
 * required other actions (do in Controller-Component (by convention)):
 *
 * - call "setUrlParamSelectorDict()" in AppModule
 * - dispatch "refreshBSCollectionAction" on every possible refresh (timer, viewport change, ...)
 *
 * optional:
 * - call "initUserConfig()"
 * - Modify UserConfigDict and add a settings menu with <UserConfigComponent/>
 * - implement maxZoom in your app and use "genBSCollectionStatusInfoEpic()" to inform user of BSCollection status
 */

export const BSCollectionModule: Module = {
	reducerNS: BSCollectionReducerNS,
	epics: [BSCollectionFetcherEpic, BSStTagZuEpic, BSIstZeitEpic, SollIstEpic, BSPersurlEpic],
}